class MainBlog extends HTMLElement {
    constructor() {
        super();

        this.elementPerPage = parseInt(this.querySelector('.main-blog').dataset.nbShow);
        this.nbPage = Math.ceil(this.querySelectorAll('.blog-articles__article').length / this.elementPerPage);
        this.currentPage = 1;

        this.querySelectorAll('[data-page]').forEach((el) => {
            el.addEventListener('click', this.pageChange.bind(this));
        });

        this.querySelector('.pagination__previous').addEventListener('click', this.previousPage.bind(this));
        this.querySelector('.pagination__next').addEventListener('click', this.nextPage.bind(this));

        this.blocks = this.querySelectorAll('.blog-articles__article');
        console.log(this.blocks);
        this.updatePaginationButtons();
    }

    pageChange(e) {
        let page = parseInt(e.target.dataset.page);
        this.currentPage = page;

        this.querySelectorAll(`[data-page]`).forEach((el) => {
            el.classList.remove('active');
        });
        e.target.classList.add('active');

        let start = (page - 1) * this.elementPerPage;
        let end = start + this.elementPerPage - 1;

        this.blocks.forEach((el) => {
            el.classList.add('hidden');
        });

        for (let i = start; i <= end; i++) {
            this.blocks[i] ? this.blocks[i].classList.remove('hidden') : null;
        }

        this.scrollTop();
        this.updatePaginationButtons();

    }

    scrollTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    previousPage() {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.querySelector(`[data-page="${this.currentPage}"]`).click();
        }
    }

    nextPage() {
        if (this.currentPage < this.nbPage) {
            this.currentPage++;
            this.querySelector(`[data-page="${this.currentPage}"]`).click();
        }
    }

    updatePaginationButtons() {
        if (this.currentPage === 1) {
            this.querySelector('.pagination__previous').classList.add('disabled');
        } else {
            this.querySelector('.pagination__previous').classList.remove('disabled');
        }

        if (this.currentPage === this.nbPage) {
            this.querySelector('.pagination__next').classList.add('disabled');
        } else {
            this.querySelector('.pagination__next').classList.remove('disabled');
        }
    }

}

customElements.define('main-blog', MainBlog);